<template>
<div class="page-in" v-if="false">

   <div class="row pad-in yo-text-small " style="padding:10px 0;background:#E3EDF9;" >

      <div class="col s12 m8 yo-valign-bottom" style="height:160px;">
         <div class="row pad yo-align-center">
         <div class="col s12 m4 yo-bg-color-secondary " style="line-height:200%;"><a class="yo-text-bold white" href="/1699-2/">Informazioni tecniche</a></div>
         <!-- <div class="col s12 m4 yo-bg-color-secondary " style="line-height:200%;"><router-link class="yo-text-bold white" to="/loadpage/info/congressi-precedenti">Informazioni commerciali</router-link></div> -->
         <div class="col s12 m4 yo-bg-color-secondary " style="line-height:200%;"><a class="yo-text-bold white" href="/archivio-fad">Archivio catalogo</a></div>
         </div>
      </div>

      <div class="col s12 m4 header yo-bg-full yo-valign-center yo-align-right" style="height:160px;" :style="{'background-image': `url(${require('../assets/catalogo-fad-secondary.png')})`}">
         <div class="arnoprodisplay yo-text-bold">
            <div class="yo-text-xxl yo-align-center">Catalogo</div>
            <div class="yo-text-l yo-align-right" style="width:70%;"> corsi FAD</div>
         </div>
      </div>
   </div>


   <div class="row  yo-text-small " style="margin-top:20px;" >
      <div class="col s12" style="height:340px;overflow:hidden;border:2px solid #fff;">
         <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/fad-medicina-full.png')})`}">
            <div class="yo-bg-transparency-black white yo-text-l" style="padding:8px 20px;">AREA MEDICINA DI LABORATORIO E ALTRE AREE</div> 
         </div>
      </div>
   </div>

   <div class="row pad-in " style="padding:20px 0;background:#E3EDF9;" >
      <div class="col s12 evento-elenco-fad">
         <evento v-for="item in eventi" :evento="item" :key="item.id" class="medicina"></evento>
      </div>
   </div>

   <div class="row  yo-text-small " style="margin-top:20px;" >
      <div class="col s12" style="height:340px;overflow:hidden;border:2px solid #fff;">
         <div class="yo-bg-cover" style="height:100%;width:100%;" :style="{'background-image': `url(${require('../assets/fad-pediatria-full.png')})`}">
            <div class="yo-bg-transparency-black white yo-text-l" style="padding:8px 20px;">AREA PEDIATRIA E NEONATOLOGIA</div> 
         </div>
      </div>
   </div>

   <div class="row pad-in " style="padding:20px 0;background:#E3EDF9;" >
      <div class="col s12 evento-elenco-fad pediatria">
         <evento v-for="item in pediatria" :evento="item" :key="item.id"></evento>
      </div>
   </div>

  <!-- SEZIONE INTERESSE O RANDOM 
   <eventiInteresse></eventiInteresse>
  -->
   <!-- SEZIONE AREE -->
   <aree></aree>

</div>
</template>

<script>
import evento from '../components/Evento-elenco-fad'
import eventiInteresse from '../components/Eventi-interesse'
import aree from '../components/Aree'

export default {
   name: 'home',
   components: {
      eventiInteresse,
      aree,
      evento
   },
   created () {
      window.location.href = "https://biomedia.net/ecm/fad/";

      this.$teras.page.title = "BioMedia - Corsi FAD"
      this.$teras.page.sezione = "EVENTI FAD"
   },
   computed: {
      eventi: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1 && this.$teras.findinset(2,item.macroarea))
               itemFilter.push(item) 
         }
         return itemFilter.sort(this.$teras.compareValues('iniziail','desc'))
      },
      pediatria: function () {
         var itemFilter = []
         for (let item of this.$teras._evento){
            if(this.$moment().isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione==1 && this.$teras.findinset(1,item.macroarea))
               itemFilter.push(item) 
         }
         return itemFilter.sort(this.$teras.compareValues('iniziail','desc'))
      }
   }
}
</script>


<style>
.arrow-right {
  width: 0; 
  height: 0; 
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  float:left;
  border-left: 14px solid white;

  margin-top:6px;
}
.catalogo-fad .header{
   background-image:url('../assets/catalogo-fad.png');
}
.fad-evidenza{
   padding-top:10px;
   height:170px;overflow:hidden;
}
.fad-evidenza:first-child{
   padding-top:20px;
   height:180px;overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Fad.vue